import { IBaseEntity, UpdateOmitBaseEntityKeys } from "../system/BaseEntity";
import { IEmailTemplate } from "../emailTemplates/EmailTemplate";
import { ITheme } from "../theme/Theme";

export enum Section {
  Main = 0,
  Article = 1,
  Property = 2,
  Testimonial = 3,
  BranchDetails = 4,
}

export interface INewsletterThemeTemplate extends IBaseEntity {
  section: Section;
  themeId?: string;
  theme?: ITheme;
  emailTemplateId?: string;
  emailTemplate?: IEmailTemplate;
}

export interface NewsletterThemeTemplateUpdate
  extends Omit<INewsletterThemeTemplate, UpdateOmitBaseEntityKeys | "id" | "theme" | "emailTemplate"> {
  subject: string;
  body: string;
}

